(ns app.api-webhook.register
  "UI register entries for the API webhook slice."
  (:require [app.api-webhook.page :as page]))

(def register
  [page/page])
